export default "__VITE_ASSET__BIxixqgg__"